import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { IbanForm, StripeCreditCardLayout, StripeLoader } from '#src/app/shared/components/payments';

import { useUpdatePaymentMethod } from './hooks/useUpdatePaymentMethod';

export const UpdatePaymentMethod: React.FC = () => {
	const {
		data: {
			loadingUpdatePaymentMethod,
			selectedPaymentType,
			email,
			userName,
			paymentMethodSaveOptions,
			countryCode,
			currency,
		},
		actions: {
			beforeToken,
			withToken,
			onTokenError,
			onTokenInvalid,
			onCardDetailsFieldFocus,
			onFieldFocusIban,
			validate,
		},
	} = useUpdatePaymentMethod();

	return (
		<StripeLoader>
			{selectedPaymentType === 'creditCard' && (
				<StripeCreditCardLayout
					layout="single"
					beforeToken={beforeToken}
					email={email}
					name={userName}
					data-testid="stripe-form-update-payment-method"
					submitButton={
						<Button
							className="w-full"
							variant="primary"
							type="submit"
							data-testid="save-payment-info-button"
							data-qa="save-payment-info-button"
							loading={loadingUpdatePaymentMethod}
						>
							<Translate value="fe.pages.subscriptions.manage.update_payment_method" />
						</Button>
					}
					onTokenError={onTokenError}
					onTokenInvalid={onTokenInvalid}
					paymentMethodSaveOptions={paymentMethodSaveOptions}
					validate={validate}
					withToken={withToken}
					onCardDetailsFieldFocus={onCardDetailsFieldFocus}
					countryCode={countryCode}
					currency={currency}
					disabled={loadingUpdatePaymentMethod}
				/>
			)}

			{selectedPaymentType === 'sepa' && (
				<>
					<IbanForm
						email={email}
						name={userName}
						currency={currency}
						countryCode={countryCode}
						paymentMethodSaveOptions={paymentMethodSaveOptions}
						validate={validate}
						beforeToken={beforeToken}
						onTokenError={onTokenError}
						onTokenInvalid={onTokenInvalid}
						withToken={withToken}
						onFieldFocus={onFieldFocusIban}
						submitButton={
							<Button
								className="w-full"
								variant="primary"
								type="submit"
								data-testid="save-payment-info-button"
								data-qa="save-payment-info-button"
								loading={loadingUpdatePaymentMethod}
							>
								<Translate value="fe.pages.subscriptions.manage.update_payment_method" />
							</Button>
						}
					/>

					<Text size="x-small">
						<Translate value="fe.components.sepa.disclaimer" />
					</Text>
				</>
			)}
		</StripeLoader>
	);
};
